import * as React from 'react';
import { TabPanelContainer } from '@components/moleculs/tabs/tab-panel/styles';
import type { TabPanelProps } from '@components/moleculs/tabs/tab-panel/types';
import Box from '@mui/material/Box';
import { styled } from 'styled-components';

const Molecule: React.FC<TabPanelProps> = (props) => {
    const { children, value, name, ...other } = props;

    return (
        <TabPanelContainer
            role='tab'
            hidden={value !== name}
            id={`tab-panel-${name}`}
            aria-labelledby={`tab-${name}`}
            {...other}
        >
            {value === name && <Box>{children}</Box>}
        </TabPanelContainer>
    );
};

export const TabPanel = styled(Molecule)({});

